import {Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {config} from '../../../../config/config';
import {ImageService} from '../../../services/image.service';
import {VisitorDataCache} from '../../../stores/visitor.calendar.store';

@Component({
    selector: 'ig-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ImageComponent implements OnInit {
    @Input() public imageUrl: any;
    @Input() public alt = 'picture';
    @Input() public placeCategoryList: string[];
    @Input() public width = 'auto';
    @Input() public height = 'auto';
    public isContainImage = false;
    private defaultImgUrl = 'https://imgoingcalendar.com/assets/imgs/place-holder.jpg';

    @ViewChild('image') public imageEle: ElementRef;

    constructor(private imageService: ImageService) {
    }

    public ngOnInit() {
        // if (!this.imageUrl) {
        //     this.setDefaultImageForPlace();
        // }
        this.isContainImage = !this.imageUrl;
        this.imageUrl = this.imageService.safeImage(this.imageService.imageSourceUrl(this.imageUrl));
    }

    public error() {
        // console.log(`image loading error: ${this.imageUrl}`);
        // if (this.isPlace) {
        //     this.setDefaultImageForPlace();
        // } else {
        //     this.imageUrl = this.defaultImgUrl;
        // }
        this.isContainImage = true;
        this.imageUrl = this.imageService.safeImage(this.imageService.imageSourceUrl(''));
        //this.imageUrl = this.defaultImgUrl;
        //that.onerror=null;
    }

    public loaded() {
        this.isContainImage = false;
    }

    private get isPlace() {
        return this.placeCategoryList && this.placeCategoryList.length;
    }

    private setDefaultImageForPlace() {
        if (this.isPlace) {
            let category = null;
            console.log(JSON.stringify(this.placeCategoryList));
            for (let key in VisitorDataCache.placeCategories) {
                if (VisitorDataCache.placeCategories[key] && this.placeCategoryList.any(x => VisitorDataCache.placeCategories[key].any(y => x === y))) {
                    category = key;
                    break;
                }
            }
            console.log(`this category: ${category}`);
            let array = config.placeDefaultImages[category];
            if (array && array.length) {
                this.imageUrl = config.placeDefaultImages[category].getRandom();
            } else {
                this.imageUrl = this.defaultImgUrl;
            }
        }
    }

    public updateImage(img) {
        setTimeout(() => {
            let url = this.imageService.imageSourceUrl(img);
            this.imageUrl = this.imageService.safeImage(url);
        });
    }

    public getRect(): ClientRect {
        if (this.imageEle) {
            const rect = this.imageEle.nativeElement.getBoundingClientRect();
            return rect;
        }
    }

    public setHeight(height: number) {
        this.height = `${height}px`;
        if (this.imageEle) {
            this.imageEle.nativeElement.style.transition = '100ms';
            this.imageEle.nativeElement.style.height = `${height}px`;
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image/image.component.ts